export default "/images/help-need-say.png?45e8dcf8516a85b4237d4e2f213432fd";